module.exports = __webpack_public_path__ + "../public/img/cocktail.65f6deee.png";